export enum InsightsLibraryRoutes {
    BASE = '',
    MANAGE = 'manage'
}
